import React from "react";
import PropTypes from "prop-types";
import { ExtraImgStyle } from "../styled";

const isFR = process.env.LANG_CODE==='fr-fr';

const ExtraImgIcon = ({ method }) => {
  return (
    <ExtraImgStyle onClick={() => method()}>{isFR ? "Autres images" : "More images"} ...</ExtraImgStyle>
  );
};

ExtraImgIcon.propTypes = {
  method: PropTypes.func
}

export default ExtraImgIcon;
